import React from 'react';
import styles from './Service.module.scss'
import ServiceCallsTable from "../../../components/ServiceCallsTable/ServiceCallsTable";
import {$t} from "../../../helpers/translator";
import ErrorsTable from "../../../components/ErrorsTable/ErrorsTable";
import ErrorsGraph from "../../../components/ErrorsGraph/ErrorsGraph";


const AdminService = () => {
    return (
        <div className={styles.container}>
            <div className={styles['flex-row']}>
                <div className={styles['box']}>
                    <ServiceCallsTable userType={5} header={$t('global.service.ServiceCalls')}/>
                </div>
            </div>

            <div className={styles['flex-row']}>
                <div className={styles['box']}>
                    <ErrorsTable userType={5} header={$t('global.service.platformErrors')}/>
                </div>
            </div>

            <div className={styles['flex-row']}>
                <div className={styles['box']}>
                    <ErrorsGraph userType={5} header={$t('global.service.platformErrorsGraph')}/>
                </div>
            </div>
        </div>
    )
}

export default AdminService;
